import Model from '@/lib/data/Model';

class CustomerDirector extends Model {
    static idProperty = 'id';

    fields = ['id', 'name', 'surname'];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get fullName() {
        return `${this.name} ${this.surname}`;
    }
}

export default CustomerDirector;
